import React, { useState, useEffect } from 'react';

export default function MyBooksPage({ books = [], isLoading = false }) {

  const [allBooks, setAllBooks] = useState(books);
  const [loading, setLoading] = useState(isLoading);

  useEffect(() => {
    setAllBooks(books);
  }, [books]);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);
  const booksPerPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(allBooks.length / booksPerPage);
  const startIndex = (currentPage - 1) * booksPerPage;
  const currentBooks = allBooks.slice(startIndex, startIndex + booksPerPage);
  const goToPreviousPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
  const goToNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
  const goToPage = (page) => setCurrentPage(page);

  return (
    <div className="min-h-screen px-6 py-10 bg-white text-gray-900">
      <h1 className="text-3xl font-bold text-center mb-10">My Books</h1>

      {/* Loading Spinner */}
      {loading ? (
        <div className="flex justify-center items-center min-h-[200px]">
          <div className="w-10 h-10 border-4 border-violet-800 border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : currentBooks.length === 0 ? (
        <div className="text-center text-gray-600 mt-12">
          <p>You haven't started reading yet. Start reading public domain books or your own uploaded books!</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {currentBooks.map(book => (
            <div
              key={book.book_meta_unique_id}
              className="cursor-pointer flex flex-col items-center group"
              onClick={() => window.location.href = `/read_book/${book.book_meta_unique_id}`}
            >
              <img
                src={book.book_cover}
                alt={book.book_name}
                className="w-full h-full object-cover rounded-lg shadow-md transition-transform group-hover:scale-105"
              />
              <p className="mt-2 text-sm font-medium text-gray-800 text-center line-clamp-2">
                {book.book_name}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="mt-10 flex justify-center items-center space-x-2">
          <button
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => goToPage(i + 1)}
              className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-violet-900 text-white' : 'bg-white text-gray-700'}`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => {
              goToNextPage();
            }}
            disabled={currentPage === totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
